import { useEffect, useRef } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

/**
 * Auto-scrolls to Review section when returning from document preview
 * Uses the reviewRef to scroll
 */
export default function useReviewAutoScroll(
  reviewRef: React.RefObject<HTMLDivElement>,
  loading: boolean
) {
  const hasScrolled = useRef(false);

  useEffect(() => {
    // Only scroll once and when data is loaded
    if (hasScrolled.current || loading) {
      return;
    }

    // Check sessionStorage for scroll indicator
    const shouldScroll = storage.getSessionStorageItem(
      STRATEGIC_STORAGE_KEY.PUBLISHING_PROJECT_REVIEW_ID
    );

    if (shouldScroll) {
      // Wait for project data to load, then scroll to Review section
      setTimeout(() => {
        if (reviewRef.current) {
          reviewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          hasScrolled.current = true;
        }
        
        // Clear the indicator after scrolling
        storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.PUBLISHING_PROJECT_REVIEW_ID);
      }, 800); // Delay to allow project data to load after URL-based selection
    }

  }, [reviewRef, loading]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.PUBLISHING_PROJECT_REVIEW_ID);
    };
  }, []);
}

